// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__8rU1t","l2":"styles_l2__Jjfid"};